import { post } from '@/common/request/index';

const OPTIONS = { isMock: false, mockId: 0, mockSuffix: '/api', needHint: true };

/** 整体保存任务集合，允许空集合解除全部关联。 */
/** 接口文档：https://yapi.lanhanba.com/project/532/interface/api/101460 */
export function saveChancePointCheckSpotTasks(params: { id: number; checkSpotTaskIds: number[] }) {
  return post('/standard/chancePoint/bindCheckSpotTask', params, OPTIONS);
}

/** 关联专用共享查询，不改变普通个人任务列表的数据范围。
 * 101454：关键词搜索/按ids回显共用接口，返回objectList、totalNum。
 */
export function searchChancePointCheckSpotTasks(params: { keyword?: string; ids?: number[]; cityIds?: number[]; page: number; size: number }) {
  return post('/checkSpotTask/simpleSearch', params, OPTIONS);
}
